import { useCallback } from 'react';

import DashboardOutlined from '@mui/icons-material/DashboardOutlined';

import Catalog from '@/assets/icons/Catalog';
import { SPOT_CATALOG_PATH } from '@/constants/constants';
import { DataHubEmptyState } from '@/features/DataHub/components/DataHubEmptyState';
import { useAppDispatch } from '@/hooks/redux-hooks';
import { closeDrawer } from '@/slices/drawerSlice';

const ExportDrawerEmptyState = () => {
  const dispatch = useAppDispatch();

  const handleCloseDrawer = useCallback(() => {
    dispatch(closeDrawer());
  }, [dispatch]);

  return (
    <DataHubEmptyState
      actions={[
        {
          label: 'Homepage',
          to: '/markets',
          icon: <DashboardOutlined />,
          replace: true,
          onClick: handleCloseDrawer
        },
        {
          label: 'Catalog',
          to: `/catalog/${SPOT_CATALOG_PATH}`,
          icon: <Catalog />,
          replace: true,
          onClick: handleCloseDrawer
        }
      ]}
      description='Get started with one of the options below:'
      title='Ready to export data?'
    />
  );
};

export default ExportDrawerEmptyState;
